module.exports = __webpack_public_path__ + "img/helicopter.ff4f7439.svg";